// src/Home.js
import React from 'react';

const Home = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>Welcome to the Home Page</h1>
      <p>
        This is a public page. Please log in to access secure content.
      </p>
    </div>
  );
};

export default Home;
